import moment, { Moment } from 'moment';
import { isPresent } from '../utils/typescript';
import User from './User';

export interface ModelID {
  [key: string]: any;
}

export default class BaseModel<ID> {
  id: ID | null = null;
  createdBy: User | null = null;
  createdOn: Moment | null = moment();
  updatedBy: User | null = null;
  updatedOn: Moment | null = null;
  removedBy: User | null = null;
  removedOn: Moment | null = null;

  get creator(): User | null {
    return this.createdBy;
  }

  set creator(user: User | null) {
    this.createdBy = user;
  }

  get modifier(): User | null {
    return this.updatedBy;
  }

  set modifier(user: User | null) {
    this.updatedBy = user;
  }

  get modifiedBy(): User | null {
    return this.updatedBy;
  }

  set modifiedBy(user: User | null) {
    this.updatedBy = user;
  }

  get modifiedOn(): Moment | null {
    return this.updatedOn;
  }

  set modifiedOn(m: Moment | null) {
    this.updatedOn = m;
  }

  get deletedBy(): User | null {
    return this.removedBy;
  }

  set deletedBy(user: User | null) {
    this.removedBy = user;
  }

  get deletedOn(): Moment | null {
    return this.removedOn;
  }

  set deletedOn(m: Moment | null) {
    this.removedOn = m;
  }

  isSaved(): boolean {
    return isPresent(this.id);
  }

  touch(user: User, time = moment()): void {
    if (this.isSaved()) {
      this.modifiedBy = user;
      this.modifiedOn = time;
    } else {
      this.createdBy = user;
      this.createdOn = time;
    }
  }
}
